import React, { createContext } from "react";
import { Status, Tag, Topic } from "./types";

export const StatusesContext = createContext<Status[]>([]);
export const TopicsContext = createContext<Topic[]>([]);
export const TagsContext = createContext<Tag[]>([]);
